'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'newsEventsLanding', () => ({

		totalPages: false,
		exhausted : false,

		init() {

			document.addEventListener( 'facetwp-loaded', () => {

				if ( ( false === this.totalPages ) && ( '' === window.location.search ) ) {

					// The initial state.

					// Place the newsletter sign up after the 5th result and unhide it.
					const gridItems = this.$refs.postsGrid.querySelectorAll( 'grid-item' );

					if ( 5 <= gridItems.length ) {
						const fifthChild = gridItems[4];
						fifthChild.after( this.$refs.newsletterSignup );
						this.$refs.newsletterSignup.classList.remove( 'hidden' );
					}

					// Set our first iteration of "totalPages" to the actual
					// total pages minus 1 (for having already displayed the
					// first page).
					this.totalPages = FWP.response.settings.pager.total_pages - 1;

				} else {

					// Continue decrementing the total pages until we reach zero.
					this.totalPages = this.totalPages - 1;
				}

				// We've exhausted the list. Completely hide the "Load More"
				// button's container.
				if ( 0 === this.totalPages ) this.exhausted = true;

				// Console.log all of our checkbox filters.
				const facets = document.querySelectorAll( '.facetwp-type-checkboxes' );
				facets.forEach( facet => {
					const checkboxes = facet.querySelectorAll( '.facetwp-checkbox' );

					if ( 0 === checkboxes.length ) {
						facet.parentElement.parentElement.classList.add( 'disabled' );
					} else {
						facet.parentElement.parentElement.classList.remove( 'disabled' );
					}
				});
			});
		}
	}) );
});
